export default {
  tenderList: {
    listSeparator: ', ',
    columns: {
      tenderCode: 'Tender No.',
      title: 'Tender Title',
      status: 'Tender Status',
      transportModes: 'Transport Mode',
      tenderCompanyName: 'Tendering Company',
      tenderCompany: 'Tendering Company',
      startTime: 'Start Time',
      endTime: 'End Time',
      tenderType: 'Tender Type',
      bidderVisibility: 'Bidder Visibility',
      biddingRounds: 'Bidding Rounds',
      requireDeposit: 'Deposit Required',
      depositAmount: 'Deposit Amount (CNY)',
      depositDeadline: 'Deposit Deadline',
      creator: 'Created By',
      createTime: 'Created At',
      updater: 'Updated By',
      updateTime: 'Updated At',
      invitationMode: 'Invitation Mode',
      currentRound: 'Current Round',
      currentRoundStartTime: 'Start Time',
      currentRoundEndTime: 'End Time',
      createdBy: 'Created By',
      dateCreated: 'Created At',
      operations: 'Actions'
    },
    filters: {
      tenderCode: 'Tender No.',
      tenderCodePlaceholder: 'Enter tender number',
      title: 'Tender Title',
      titlePlaceholder: 'Enter tender title',
      status: 'Tender Status',
      statusPlaceholder: 'Select tender status',
      tenderCompanyName: 'Tendering Company',
      tenderCompanyNamePlaceholder: 'Enter tendering company',
      tenderCompany: 'Tendering Company',
      tenderCompanyPlaceholder: 'Enter tendering company',
      startTime: 'Start Time',
      startTimePlaceholder: 'Select start time range',
      endTime: 'End Time',
      endTimePlaceholder: 'Select end time range',
      tenderType: 'Tender Type',
      tenderTypePlaceholder: 'Select tender type',
      transportModes: 'Transport Mode',
      transportModesPlaceholder: 'Select transport mode',
      bidderVisibility: 'Bidder Visibility',
      bidderVisibilityPlaceholder: 'Select bidder visibility',
      biddingRounds: 'Bidding Rounds',
      biddingRoundsPlaceholder: 'Enter bidding rounds',
      requireDeposit: 'Deposit Required',
      requireDepositPlaceholder: 'Select whether deposit is required',
      depositAmount: 'Deposit Amount',
      depositAmountPlaceholder: 'Enter deposit amount',
      depositDeadline: 'Deposit Deadline',
      depositDeadlinePlaceholder: 'Select deposit deadline range',
      creator: 'Created By',
      creatorPlaceholder: 'Select creator',
      dateCreated: 'Created At',
      dateCreatedPlaceholder: 'Select creation date range',
      createTime: 'Created At',
      createTimePlaceholder: 'Select creation date range',
      updater: 'Updated By',
      updaterPlaceholder: 'Select updater',
      updateTime: 'Updated At',
      updateTimePlaceholder: 'Select update date range'
    },
    statuses: {
      draft: 'Draft',
      ongoing: 'Ongoing',
      full: 'Bidding Completed - Full',
      underSubscribed: 'Bidding Completed - Under-subscribed',
      failed: 'Failed',
      withdrawn: 'Withdrawn',
      evaluating: 'Evaluating',
      awarded: 'Awarded'
    },
    transportModes: {
      fcl: 'FCL',
      lcl: 'LCL',
      air: 'AIR'
    },
    transportModeShortLabels: {
      fcl: 'FCL',
      lcl: 'LCL',
      air: 'AIR'
    },
    tenderTypes: {
      year: 'Annual Tender',
      quarter: 'Quarterly Tender',
      month: 'Monthly Tender'
    },
    bidderVisibility: {
      hidden: 'Hidden'
    },
    boolean: {
      yes: 'Yes',
      no: 'No'
    },
    invitationModes: {
      directed: 'Directed Invitation'
    },
    actions: {
      addTender: 'New Tender',
      shareLink: 'Share Link',
      sendEmail: 'Send Email',
      batchPublish: 'Batch Publish',
      batchDelete: 'Batch Delete',
      view: 'View',
      edit: 'Edit',
      publish: 'Publish',
      more: 'More',
      withdraw: 'Withdraw',
      delete: 'Delete',
      copy: 'Copy'
    },
    messages: {
      loadFailed: 'Failed to load tenders. Please try again later.',
      selectOneForShare: 'Select exactly one tender before sharing the link.',
      selectOneForEmail: 'Select exactly one tender before sending email.',
      onlyOngoingForEmail: 'Invitation emails can only be sent for ongoing tenders.',
      selectTenderFirst: 'Select tenders before {action}.',
      onlyDraftAllowed: 'Only draft tenders can be {action}.',
      publishConfirmTitle: 'Confirm Tender Publication',
      publishConfirmContent: 'Publish tender {code}? Its status will change to ongoing.',
      batchPublishConfirmContent: 'Publish the selected {count} tenders? Their status will change to ongoing.',
      publishSuccess: '{count} tender(s) published.',
      publishPartial: 'Publication completed: {success} succeeded and {failed} failed. Check required draft information.',
      withdrawConfirmTitle: 'Confirm Tender Withdrawal',
      withdrawConfirmContent: 'Withdraw tender {code}? Supplier bidding links will become invalid immediately, and the original tender can only be viewed or copied.',
      withdrawSuccess: 'The tender has been withdrawn.',
      withdrawFailed: 'Failed to withdraw the tender. Refresh and try again.',
      copyConfirmTitle: 'Confirm Tender Copy',
      copyConfirmContent: 'Copy tender {code}? A new independent draft will be created.',
      copySuccess: 'Tender copied. The new tender number is {code}.',
      copyFailed: 'Failed to copy the tender. Please try again later.',
      deleteConfirmTitle: 'Confirm Delete',
      deleteConfirmContent: 'Delete tender {code}? This action cannot be undone.',
      batchDeleteConfirmContent: 'Delete the selected {count} tenders? This action cannot be undone.',
      deleteSuccess: 'Successfully deleted {count} tender(s)',
      deletePartial: 'Delete completed: {success} succeeded, {failed} failed. Refresh and retry if needed.',
      deleteFailed: 'Failed to delete the tender. Refresh and try again.'
    }
  },
  invitationMail: {
    title: 'Send Email',
    template: 'Email Template:',
    templatePlaceholder: 'Select an email template',
    preview: 'Email Preview:',
    companies: 'Recipient Companies:',
    companiesPlaceholder: 'Select recipient companies',
    privateLinkMask: '[A private link will be generated after sending and will only be visible in the recipient email]',
    privateLinkHint: 'The private bidding link is only written to the matching supplier contact email. Each company receives a different link and token.',
    noEmail: 'Email not provided',
    emptyTemplate: 'No enabled tender invitation email template is configured.',
    templateLoadFailed: 'Failed to load email templates. Please try again later.',
    selectTemplate: 'Select an email template.',
    selectCompany: 'Select at least one recipient company with a valid email.',
    sendSuccess: 'Email sent successfully to {count} company(ies).',
    sendFailed: 'Failed to send email. Please try again later.',
    cancel: 'Cancel',
    send: 'Send Email'
  },
  tenderDetail: {
    titles: {
      create: 'New Tender',
      edit: 'Edit Tender',
      view: 'Tender Details: {title} ({code})',
      unnamed: 'Untitled Tender'
    },
    steps: {
      basicAndMethod: 'Basic Info',
      subject: 'Subject Items'
    },
    sections: {
      basicInfo: 'Basic Information',
      invitationMethod: 'Invitation Method',
      supplierList: 'Supplier List',
      evaluationTeam: 'Evaluation Team',
      bidderInfo: 'Bidder Information',
      subjectInfo: 'Subject Information',
      feeSettings: 'Fee Filling Settings',
      routeConfig: 'Route Configuration',
      attachments: 'Tender Attachments'
    },
    fields: {
      tenderCode: 'Tender No.',
      title: 'Tender Title',
      tenderCompany: 'Tendering Company',
      tenderType: 'Tender Type',
      cargoType: 'Cargo Type',
      invitationMode: 'Invitation Mode',
      bidderVisibility: 'Bidder Visibility',
      startTime: 'Current Round Start Time',
      endTime: 'Current Round End Time',
      biddingRounds: 'Bidding Rounds',
      maxBidCount: 'Maximum Bid Count',
      minBidCount: 'Minimum Bid Count',
      winningBidCount: 'Winning Count',
      contractStartDate: 'Contract Start Date',
      contractEndDate: 'Contract End Date',
      requireDeposit: 'Deposit Required',
      depositAmount: 'Deposit Amount (CNY)',
      depositDeadline: 'Deposit Deadline',
      transportModes: 'Transport Mode',
      remark: 'Remark'
    },
    tenderCompanies: {
      shokz: 'Shokz'
    },
    columns: {
      index: 'No.',
      supplierName: 'Supplier Name',
      contactName: 'Contact',
      email: 'Email',
      bidStatus: 'Bid Status',
      qualificationStatus: 'Qualification',
      winStatus: 'Award Status',
      bidBook: 'Bid Book',
      operationHistory: 'Operation History',
      winningRoutes: 'Award Information',
      awardInfo: 'Award Information',
      awardPercentage: 'Award Percentage',
      winner: 'Winner',
      operation: 'Actions',
      permit: 'Permission Type',
      memberRole: 'Member Role',
      quoteVisibility: 'Quote Visibility',
      dataScope: 'Data Scope',
      department: 'Department',
      memberName: 'Name',
      routeCode: 'Route Code',
      tenderScheme: 'Tender Scheme',
      originCountry: 'Origin Country',
      originPort: 'Origin Port',
      originAirport: 'Origin Airport',
      originCity: 'Origin City',
      originWarehouse: 'Origin Warehouse',
      destinationCountry: 'Destination Country',
      destinationPort: 'Destination Port',
      destinationAirport: 'Destination Airport',
      destinationCity: 'Destination City',
      destinationWarehouse: 'Destination Warehouse',
      benchmark: 'Benchmark',
      serviceType: 'Service Type',
      transportClause: 'Transport Clause',
      tradeClause: 'Trade Clause',
      weightKg: 'Weight (kg)',
      weightKgFcl: 'Weight(kg)',
      weightKgMixed: 'Weight(KG)',
      cbm: 'Volume (CBM)',
      cbmPrototype: 'Volume(CBM)',
      containerType: 'Container Type',
      quantity: 'Quantity',
      winnerMerged: 'Winner (Merged)',
      totalPrice: 'Total Cost',
      comprehensiveScore: 'Comprehensive Score',
      maxPrice: 'Max Price (USD)',
      minPrice: 'Min Price (USD)',
      tenderRemark: 'Tender Remark',
      priceLimit: 'Price Limit',
      remark: 'Remark'
    },
    attachmentColumns: {
      name: 'File Name',
      size: 'File Size',
      uploader: 'Uploaded By',
      uploadTime: 'Upload Time'
    },
    actions: {
      back: 'Back',
      cancel: 'Cancel',
      close: 'Close',
      saveDraft: 'Save Draft',
      publish: 'Publish Tender',
      edit: 'Edit',
      view: 'View',
      confirmQualification: 'Confirm',
      openTender: 'Open Bids',
      viewOpening: 'View Opening Details',
      exportBidInfo: 'Export Bid Information',
      withdraw: 'Withdraw',
      addSupplier: 'Add Supplier',
      addMember: 'Add Member',
      addRoute: 'Add Route',
      batchUpload: 'Batch Upload',
      selectAll: 'Select All',
      batchDeleteRoutes: 'Batch Delete ({count})',
      setContainer: 'Set Containers',
      collapse: 'Collapse ▲',
      expand: 'Expand ▼',
      saveAsScheme: 'Save Scheme',
      resetDefault: 'Reset to Default',
      delete: 'Delete',
      download: 'Download',
      nextStep: 'Next: Subject Items',
      prevStep: 'Back to Basic Info'
    },
    placeholders: {
      autoGenerate: 'Auto-generated',
      title: 'Enter tender title',
      tenderCompany: 'Select or enter tendering company',
      tenderType: 'Select tender type',
      cargoType: 'Select cargo type',
      startTime: 'Select start time',
      endTime: 'Select end time',
      remark: 'Enter remark',
      supplierName: 'Select or enter supplier',
      contactName: 'Select contact',
      email: 'Enter email address',
      permit: 'Select permission type',
      department: 'Select or enter department',
      memberName: 'Select or enter name',
      currentUserAutoFill: 'Current creator will be filled on save',
      routeCode: 'Auto-generated after save',
      originCountry: 'Country is required',
      originPort: 'Port is optional',
      destinationCountry: 'Country is required',
      destinationPort: 'Port is optional',
      containerType: 'Select container type'
    },
    validation: {
      titleRequired: 'Enter tender title',
      cargoTypeRequired: 'Select cargo type',
      tenderCompanyRequired: 'Select tendering company',
      tenderTypeRequired: 'Select tender type',
      startTimeRequired: 'Select current round start time',
      endTimeRequired: 'Select current round end time',
      endTimeAfterStart: 'End time must be later than start time',
      endTimeAfterNow: 'The tender end time must be later than the current time',
      biddingRoundsRequired: 'Enter bidding rounds',
      minBidCountRequired: 'Enter minimum bid count',
      bidCountRangeInvalid: 'The minimum bid count cannot exceed the maximum bid count',
      supplierCountLimit: 'The number of suppliers cannot exceed the maximum bid count ({count})',
      winningBidCountRequired: 'Enter winning count',
      contractStartDateRequired: 'Select contract start date',
      contractEndDateRequired: 'Select contract end date',
      contractEndDateAfterStart: 'Contract end date must be later than start date',
      depositAmountRequired: 'Enter deposit amount',
      depositDeadlineRequired: 'Select deposit deadline',
      transportModeRequired: 'Select at least one transport mode',
      supplierRequired: 'Add at least one invited supplier',
      supplierIncomplete: 'Select a supplier and contact with a valid email for every row',
      evaluationMemberInvalid: 'Evaluation members cannot be duplicated',
      routeModeRequired: 'Add at least one route for {mode}',
      routeFieldRequired: 'Origin country, destination country, service type, transport clause, and trade clause are required for {mode} route {index}',
      originLocationRequired: 'Pre-carriage fees are selected for {mode} route {index}. Enter an origin city or shipping warehouse.',
      destinationLocationRequired: 'Last-mile fees are selected for {mode} route {index}. Enter a destination city or receiving warehouse.',
      routeMetricPositive: 'Weight and volume must be greater than zero for {mode} route {index}',
      containerRequired: 'Add at least one container type for FCL route {index}',
      containerInvalid: 'FCL route {index} has an empty/duplicated container type or invalid quantity',
      priceLimitInvalid: 'The minimum and maximum price limits are invalid for {mode} route {index}',
      attachmentTypeInvalid: 'Only PDF, Word, Excel, JPG, JPEG, and PNG files are supported',
      attachmentSizeLimit: 'Maximum size per file: 10 MB',
      batchUploadFileType: 'Only .xls, .xlsx, or .csv files are supported',
      batchUploadEmpty: 'No importable subject routes were found in the file'
    },
    hints: {
      winningBidCount: 'Maximum winning suppliers for each route/container',
      feeSettings: 'Configure the fee items suppliers must fill in for each transport business type.',
      quantityOptional: 'Optional for the tenderer; suppliers see a read-only empty value when omitted.',
      subjectGrid: 'Use the Columns button on the right to configure visible columns. Fields marked * are required for publishing; optional city, warehouse, and quantity columns are hidden by default.',
      tenderSchemeCompositionTitle: 'Composition',
      tenderSchemeCompositionNote: 'Shows tender-filled fields only; read-only',
      tenderSchemeDetailTitle: 'Tender Scheme Details',
      tenderSchemeCompositionPrefix: 'Composition: ',
      tenderSchemeFormulaSea: 'Origin Country-Origin Port-Origin City-Origin Warehouse-Destination Country-Destination Port-Destination City-Destination Warehouse',
      tenderSchemeFormulaAir: 'Origin Country-Origin Airport-Origin City-Origin Warehouse-Destination Country-Destination Airport-Destination City-Destination Warehouse',
      batchUpload: 'Right-click the route grid to export a template, then upload the completed .xls, .xlsx, or .csv file.'
    },
    feeSettings: {
      billingUnit: 'Billing Unit',
      currency: 'Currency',
      currentScheme: 'Current Scheme:',
      noScheme: 'No scheme selected',
      saveTitle: 'Save Fee Scheme',
      schemeName: 'Scheme Name',
      schemeDescription: 'Description (Optional)',
      schemeNamePlaceholder: 'e.g. US Line Standard Scheme',
      schemeDescriptionPlaceholder: 'Describe when this scheme should be used',
      setAsDefault: 'Set as default (preferred for new tenders)',
      defaultTag: 'Default',
      empty: 'No enabled fee items are available for this transport mode.',
      refresh: 'Reload fee items from fee management',
      required: 'Required',
      optional: 'Optional',
      minMax: 'Min/Max',
      groups: {
        origin: 'Pre-carriage',
        basic: 'Mainline',
        destination: 'On-carriage'
      }
    },
    batchUpload: {
      downloadTitle: 'Export Subject Template',
      downloadDescription: 'The template columns match the route grid for the current transport mode.',
      downloadAll: 'Download All Templates',
      rightClickTip: 'Right-click any data cell in the route grid and choose Export → Export to Excel or Export to CSV.',
      uploadTitle: 'Upload File',
      dropHint: 'Drag a file here or click to upload',
      fileTypes: '.xls, .xlsx, and .csv files are supported'
    },
    importErrors: {
      title: 'Import Validation Failed',
      summary: '{count} issue(s) were found. No rows were applied. Correct the file and import it again.',
      sheet: 'Sheet',
      row: 'Row',
      column: 'Field',
      value: 'Original Value',
      reason: 'Issue',
      currentDuplicate: 'This route duplicates a route already on the current page.'
    },
    subjectOptions: {
      economy: 'Economy',
      express: 'Express',
      enabled: 'Enabled',
      minPrice: 'Min',
      maxPrice: 'Max',
      none: 'None'
    },
    subjectSummary: {
      fcl: '{routes} routes and {containers} container configurations',
      routes: '{routes} routes',
      readonlyFooter: '{count} records | Tender scheme: {formula}'
    },
    awardInfo: {
      title: 'Award Information',
      supplierTitle: '{supplier} - Award Information',
      winnerFallback: 'Winner',
      summary: '{count} route(s) · {percentages}',
      subjectRecords: '{count} record(s)',
      totalRecords: '{count} awarded record(s)',
      routeFormula: 'Route code formula: {formula}',
      routeFormulaValue: 'Origin port-city-destination port-city-transport mode',
      routeFormulaAirValue: 'Origin airport-city-destination airport-city-transport mode',
      supplierRouteFormula: 'Tender scheme: {formula}',
      supplierRouteFormulaValue: 'Origin Country-Origin Port-Origin City-Origin Warehouse-Destination Country-Destination Port-Destination City-Destination Warehouse',
      supplierRouteFormulaAirValue: 'Origin Country-Origin Airport-Origin City-Origin Warehouse-Destination Country-Destination Airport-Destination City-Destination Warehouse',
      routingType: 'Routing Type',
      transitPort: 'Transit Port',
      validityLegend: 'Rate Validity',
      transitLegend: 'Route Information',
      effectiveDate: 'Effective Date',
      expiryDate: 'Expiry Date',
      carrier: 'Carrier',
      airCarrier: 'Air Carrier',
      vesselSchedule: 'Vessel Schedule',
      flightSchedule: 'Flight Schedule',
      transitTimeDays: 'Transit Time',
      freeContainerDays: 'Free Container Days',
      freeStorageDays: 'Free Storage Days',
      destClearanceDays: 'Destination Clearance',
      airportFreeStorage: 'Airport Free Storage',
      achievementRate: 'Achievement Rate',
      ddType: 'POD D&D Type',
      ddMixedDays: 'POD D&D Mixed',
      ddDemurrageDays: 'POD D&D Demurrage',
      ddDetentionDays: 'POD D&D Detention',
      storageDays: 'POD Storage Days',
      feeSummary: 'Fee Details',
      transitTime: 'Transit Time',
      validity: 'Validity',
      ddSummary: 'D&D/Free Days',
      remark: 'Bid Remark',
      day: 'day(s)',
      noBid: 'No bid record is available for award information.',
      noSupplierAward: 'This supplier has no award information.',
      supplierLoadFailed: 'Failed to load the supplier bid quotes.',
      noQuote: 'No awarded bid details are available.',
      noSubject: 'No subject items are available.'
    },
    attachments: {
      uploadTitle: 'Click or drag files here to upload',
      supportedTypes: 'PDF, Word, Excel, and image files are supported',
      sizeLimit: 'Maximum size per file: 10 MB',
      uploadedFiles: 'Uploaded Files ({count})',
      empty: 'No uploaded files'
    },
    permits: {
      fullView: 'Full View',
      fullEdit: 'Full Edit'
    },
    bidderStatus: {
      bid: { NOT_BID: 'Not Bid', DRAFT: 'Draft', SUBMITTED: 'Submitted' },
      qualification: { UNCONFIRMED: 'Unconfirmed', CONFIRMED: 'Confirmed' },
      win: { NOT_OPENED: 'Not Opened', WON: 'Awarded', PARTIAL: 'Partially Awarded', LOST: 'Not Awarded' }
    },
    bidderHistory: {
      title: '{supplier} · Operation History',
      viewTab: 'Bid View History ({count})',
      mailTab: 'Email History',
      viewer: 'Viewer',
      sender: 'Sender',
      department: 'Department',
      viewType: 'View Source',
      viewTime: 'View Time',
      receiverEmail: 'Recipient Email',
      receiverName: 'Recipient/Company',
      emailType: 'Email Type',
      sendTime: 'Sent At',
      emailContent: 'Email Content',
      viewTypes: { BID_VIEW: 'Bid Details', CROSS_BID_VIEW: 'Cross-bid Evaluation' },
      emailTypes: { INVITATION: 'Tender Invitation', AWARD: 'Award Notice' }
    },
    opening: {
      confirmTitle: 'Confirm Bid Opening',
      confirmContent: 'After opening, the tender enters evaluation and submitted bid books become visible to authorized evaluators. Continue?',
      referenceTitle: 'Complete Evaluation References',
      referenceHintPrefix: 'Some routes have no quotes for an entire',
      referenceSegments: 'pre-carriage / mainline / on-carriage',
      referenceHintSuffix: 'segment. Select reference rates for evaluation; these values are highlighted in red on the opening details page.',
      confirmAndOpen: 'Save References and Open',
      route: 'Route Code',
      missingSuppliers: 'Suppliers Missing Quotes',
      companyUnit: 'supplier(s)',
      feeCategory: 'Missing Fee Segment',
      referenceAmount: 'Reference Amount',
      referenceRate: 'Reference Rate',
      referenceFootnote: 'Reference values are used only for this evaluation and do not update suppliers\' original bids. Suppliers missing the same route segment share the selected reference rate.',
      currency: 'Currency',
      referenceSource: 'Reference Source',
      manualSource: 'Manual Entry',
      rateLibrarySource: 'Rate Library',
      selectRate: 'Select from Rate Library',
      changeRate: 'Change Rate',
      referenceRequired: 'Complete all reference amounts.',
      checkFailed: 'Bid opening check failed. Refresh and try again.',
      success: 'Bids opened. The tender is now under evaluation.',
      failed: 'Failed to open bids. Refresh and try again.',
      feeCategories: { origin: 'Pre-carriage', mainline: 'Mainline', destination: 'On-carriage', whole: 'End-to-end' },
      ratePicker: {
        title: 'Select from Rate Library · {library}',
        hint: 'Select a suitable reference rate from the rate library. The selected value will be used as the evaluation reference.',
        transportMode: 'Transport Mode',
        containerType: 'Container Type',
        priceNo: 'Rate No.',
        source: 'Rate Source',
        supplier: 'Supplier',
        originPort: 'Origin Port',
        destinationPort: 'Destination Port',
        originAirport: 'Origin Airport',
        destinationAirport: 'Destination Airport',
        validPeriod: 'Valid Period',
        amountUnavailable: 'Unavailable',
        select: 'Select',
        selected: 'Selected',
        selectedPreview: 'Selected',
        cancel: 'Cancel',
        confirmSelection: 'Confirm Selection',
        selectionRequired: 'Select a reference rate.',
        manualTitle: 'Enter a Reference Manually',
        manualUnavailableDescription: 'None of the matching rates has a usable amount. Enter the amount and currency manually.',
        manualAmount: 'Reference Amount',
        manualAmountRequired: 'Enter a valid reference amount.',
        empty: 'No matching rates were found. Enter a reference value below.',
        loadFailed: 'Failed to query the rate library. Try again later or enter the reference manually.',
        libraries: { fcl: 'FCL Rates', lcl: 'LCL Rates', air: 'Air Rates' },
        sources: { inquiry: 'Inquiry', bidding: 'Tender', manual: 'Manual', system: 'System', unknown: 'Other' }
      }
    },
    export: { filePrefix: 'Bid_Information' },
    memberRoles: {
      owner: 'Full Edit',
      editor: 'Project Editor',
      viewer: 'Project Viewer'
    },
    quoteVisibility: {
      afterOpen: 'Quotes visible after opening',
      afterAward: 'Quotes visible after award'
    },
    dataScopes: {
      project: 'Entire Project',
      department: 'Department'
    },
    feeStates: {
      disabled: 'Disabled',
      optional: 'Optional',
      required: 'Required'
    },
    messages: {
      loadFailed: 'Failed to load tender details. Please try again later.',
      saveDraftSuccess: 'Tender draft saved.',
      saveDraftFailed: 'Failed to save the tender draft. Please try again later.',
      publishConfirmTitle: 'Confirm Tender Publication',
      publishConfirmContent: 'The tender status will change to ongoing. Publish now?',
      publishSuccess: 'Tender published successfully.',
      publishFailed: 'Failed to publish the tender. Check required information or refresh and try again.',
      publishAttachmentFailed: 'The draft was saved, but attachment upload failed. The tender was not published.',
      contactLoadFailed: 'Failed to load supplier contacts. Please try again later.',
      supplierDuplicate: 'The same supplier cannot be added twice.',
      evaluationDepartmentMismatch: 'Employees outside the selected department were filtered out.',
      evaluationDepartmentChanged: 'The department changed. Select names again.',
      evaluationPriceHint: 'No permission type can view prices before bid opening.',
      transportModeRequired: 'Select at least one transport mode: FCL, LCL, or AIR.',
      departmentLoadFailed: 'Failed to load business departments. Please try again later.',
      saveDraftAttachmentFailed: 'The draft was saved, but attachment upload failed. Please try again later.',
      attachmentDeleteFailed: 'Failed to delete the attachment. Please try again later.',
      attachmentDownloadFailed: 'Failed to download the attachment. Please try again later.',
      batchUploadSuccess: '{count} subject routes imported.',
      batchUploadWarehouseUnmatched: '{count} subject routes were imported. The destination warehouse in {unmatched} template row(s) did not uniquely match master data; select it again in the grid.',
      batchUploadFailed: 'Failed to parse the batch upload file. Check its format.',
      templateDownloadFailed: 'Failed to generate the subject template.',
      containerTypeEmpty: 'No enabled container types are available for the current tenant.',
      containerTypeLoadFailed: 'Failed to load container types. Please try again later.',
      feeSettingsLoadFailed: 'Failed to load fee items. Please try again later.',
      currencyOptionsLoadFailed: 'Failed to load currency options. Please try again later.',
      feeSchemesLoadFailed: 'Failed to load fee schemes. Please try again later.',
      feeSchemeNameRequired: 'Enter a fee scheme name.',
      feeSchemeSaveSuccess: 'Fee scheme saved.',
      feeSchemeSaveFailed: 'Failed to save the fee scheme. Please try again later.',
      feeSchemeDeleteConfirm: 'Delete fee scheme "{name}"?',
      feeSchemeDeleteSuccess: 'Fee scheme deleted.',
      feeSchemeDeleteFailed: 'Failed to delete the fee scheme. Please try again later.',
      feeSettingsResetSuccess: 'Fee settings were reset to the default.',
      feeSettingsRefreshSuccess: 'Fee items were reloaded from fee management.',
      bidderHistoryLoadFailed: 'Failed to load operation history. Please try again later.',
      confirmQualificationTitle: 'Confirm Qualification',
      confirmQualificationContent: 'Confirm that supplier "{supplier}" is qualified for this round?',
      qualificationConfirmed: 'Qualification confirmed.',
      noSubmittedBidToExport: 'There are no submitted bid books to export.',
      exportSuccess: 'Bid information exported successfully.',
      exportFailed: 'Failed to export bid information. Please try again later.'
    }
  },
  evaluation: {
    feeCalculation: {
      pending: 'Not calculated', formula: 'Unit rate {unitRate} × Quantity {quantity}',
      min: 'Min {value}', max: 'Max {value}', result: 'Calculated amount {amount}',
      weightBreakNote: 'Mainline shows the calculated amount for the selected weight break; totals use the tier matching the tender weight.'
    },
    title: 'Bid Opening Details: {title} ({code})',
    openingTitle: 'Bid Opening Details',
    status: 'Under Evaluation',
    hint: 'All participating quotes from submitted bid books in the current round are shown. Opening this page records a bid-book view history entry as required by the PRD.',
    nonEvaluationHint: 'This page displays opened structured bid books, records view history, and ranks quotes with the prototype scoring formulas.',
    actions: { back: 'Back', export: 'Export Bid Information', setWinner: 'Assign Winners', newRound: 'Start Next Round' },
    newRound: {
      title: 'Start Next Round',
      suppliers: 'Suppliers',
      suppliersPlaceholder: 'Select qualified suppliers from the previous round',
      startTime: 'Start Time',
      endTime: 'End Time',
      cancel: 'Cancel',
      confirm: 'Start Round',
      unavailable: 'The round limit has been reached, or no qualified submitted bids are available.',
      supplierRequired: 'Select at least one supplier.',
      timeRequired: 'Select the next-round start and end times.',
      timeInvalid: 'The end time must be after the start time and the current time.',
      success: 'Round {round} was created. Send the invitation emails.',
      failed: 'Failed to start the next round. Refresh and try again.'
    },
    sections: { filters: 'Filter Conditions', sort: 'Sort Conditions' },
    fields: {
      benchmark: 'Benchmark', routeCode: 'Route Code', scheme: 'Tender Scheme', supplier: 'Bidder', round: 'Round',
      container: 'Container Type', weightCbm: 'Weight / Volume', weightBreak: 'Weight Break', currency: 'Currency',
      originCountry: 'Origin Country', originPort: 'Origin Port', originCity: 'Origin City', originWarehouse: 'Origin Warehouse',
      destinationCountry: 'Destination Country', destinationPort: 'Destination Port', destinationCity: 'Destination', destinationWarehouse: 'Destination Warehouse'
    },
    filters: {
      benchmarkPlaceholder: 'Select benchmark',
      schemePlaceholder: 'Select tender scheme',
      supplierPlaceholder: 'Select bidders',
      roundPlaceholder: 'Select rounds',
      containerPlaceholder: 'Select container type',
      weightCbmPlaceholder: 'Select weight / volume',
      weightBreakPlaceholder: 'Select weight break (air)',
      currencyPlaceholder: 'Select currency',
      originCountryPlaceholder: 'Select origin country',
      originPortSeaPlaceholder: 'Select origin port',
      originPortAirPlaceholder: 'Select origin airport',
      originCityPlaceholder: 'Select origin city',
      originWarehousePlaceholder: 'Select origin warehouse',
      destinationCountryPlaceholder: 'Select destination country',
      destinationPortSeaPlaceholder: 'Select destination port',
      destinationPortAirPlaceholder: 'Select destination airport',
      destinationCityPlaceholder: 'Select destination',
      destinationWarehousePlaceholder: 'Select destination warehouse'
    },
    options: {
      all: 'All', benchmarkOnly: 'Benchmark Only', nonBenchmark: 'Non-benchmark', benchmarkTag: 'Benchmark'
    },
    viewSwitch: 'View: ',
    bidView: 'Bid-book View',
    scoreView: 'Score View',
    bidSortLabel: 'Bid-book Sort:',
    sortOptions: {
      price: 'Best Price', transit: 'Fastest Transit', portFront: 'Pre-carriage', mainline: 'Mainline', tail: 'On-carriage',
      mainlineWeightBreak: 'Mainline-{weightBreak}'
    },
    weightBreakOption: '{tier} ({range})',
    weightBreakHint: 'Weight break {weightBreak} selected: mainline shows its calculated amount for comparison (totals use the tender weight). Choose "{sortOption}" to rank by amount ascending.',
    scoreSortLabel: 'Score View Sort:',
    scoreSortOption: 'Highest {score}',
    comparisonHint: 'Click a total to inspect fee and route details, or click a tender scheme to inspect the complete tender subject. Supplier columns follow the selected bid-book sort order.',
    mergeHintPrefix: 'A',
    mergeHintTag: 'Merged N',
    mergeHintSuffix: 'tag indicates multiple routes with identical comparison values',
    mergeTag: 'Merged {count}',
    scoreComparisonHint: 'Click a score to inspect its calculation, a route code to inspect fees and route details, or a tender scheme to inspect the complete tender subject.',
    latest: 'Latest',
    roundValue: 'Round {round}',
    recordCount: '{count} comparison record(s)',
    common: { yes: 'Yes', no: 'No', day: 'd' },
    columns: {
      index: 'No.', supplier: 'Bidder', bidBook: 'Bid Book', round: 'Round', scheme: 'Tender Scheme',
      routeCode: 'Route Code', container: 'Container Type', weightCbm: 'Weight (kg) / Volume (CBM)', validity: 'Rate Validity', carrier: 'Carrier/Airline',
      schedule: 'Vessel/Flight Weekdays', transitDays: 'Transit Time (Days)', achievementRate: 'Overall On-time Rate', fees: 'Fee Quote', remark: 'Bid Remark'
    },
    drawers: {
      feeTitle: 'Fee Details', routeTitle: 'Tender Subject Details', feeName: 'Fee Name', currency: 'Currency',
      segmentSummary: 'Rate Library Category Summary',
      amount: 'Amount', total: 'Total', origin: 'Origin', destination: 'Destination', serviceType: 'Service Type',
      composition: 'Composition', tenderSchemeComposition: 'Tender Scheme Composition', routeLineCode: 'Route Code', routeInfo: 'Route Information',
      tenderSchemeFormulaSea: 'Origin Country-Origin Port-Origin City-Origin Warehouse-Destination Country-Destination Port-Destination City-Destination Warehouse',
      tenderSchemeFormulaAir: 'Origin Country-Origin Airport-Origin City-Origin Warehouse-Destination Country-Destination Airport-Destination City-Destination Warehouse',
      routeLineFormulaSea: 'Origin Port-Destination Port', routeLineFormulaAir: 'Origin Airport-Destination Airport',
      carrier: 'Carrier', airline: 'Airline', sailingSchedule: 'Sailing Schedule', flightSchedule: 'Flight Schedule',
      transitTime: 'Transit Time', destinationFreeDetention: 'Destination Free Detention', destinationFreeStorage: 'Destination Free Storage',
      destinationClearance: 'Destination Clearance Time', airportFreeStorage: 'Destination Airport Free Storage',
      cfsFreeStorage: 'CFS Free Storage', hour: 'h', noFeeItems: 'No fee items',
      mergedRouteTip: 'Multiple routes have identical comparison values. Click the total to switch between route details.',
      originAirportFees: 'Pre-carriage', destinationAirportFees: 'On-carriage',
      maxPrice: 'Maximum Price ({currency})', minPrice: 'Minimum Price ({currency})', tenderRemark: 'Tender Remark'
    },
    feeCategories: { origin: 'Pre-carriage', basic: 'Mainline', destination: 'On-carriage' },
    segments: { portFront: 'Pre-carriage', mainline: 'Mainline', tail: 'On-carriage' },
    score: {
      drawerNote: 'Each scoring project is displayed from the database record for the current quote row.',
      drawerNoteFclCommercial: 'Commercial scores are synthesized by 40HQ/20GP on the route (same across rows); technical and comprehensive scores are calculated per container row.',
      evaluationTable: 'Evaluation Details', evaluationScope: 'Scope', evaluationProject: 'Project',
      description: 'Description', score: 'Score', parameterTable: 'Scoring Parameters', parameter: 'Parameter', value: 'Value',
      summaryDescriptions: {
        fclCommercial: `1. Base data scope
- FCL cost: synthesized fee based on 40HQ ratio + 20GP ratio
2. Baseline cost
- FCL baseline: the lowest bid cost among all carriers in the same route group
3. Cost score conversion
- Cost score = Max(0, (2 - bid cost / baseline cost) × 100)
Note: when a route cost is twice the baseline or more, the score is 0.`,
        lclCommercial: `1. Base data scope
- LCL cost: weighted fee by quoted weight breaks and last-quarter closed volume distribution (0-300KG × X% + 300-500KG × Y%)
2. Baseline cost
- LCL baseline: the lowest synthesized fee in the 2000KG/3000KGS weight breaks within the same route group
3. Cost score conversion
- Cost score = Max(0, (2 - bid cost / baseline cost) × 100)
Note: when a route cost is twice the baseline or more, the score is 0.`,
        airCommercial: `1. Base data scope
- Air cost: weighted fee by quoted weight breaks and last-quarter closed volume distribution (0-300KG × X% + 300-500KG × Y%)
2. Baseline cost
- Air baseline: the lowest synthesized fee in the 2000KG/3000KGS weight breaks within the same route group
3. Cost score conversion
- Cost score = Max(0, (2 - bid cost / baseline cost) × 100)
Note: when a route cost is twice the baseline or more, the score is 0.`,
        technical: `1. Corrected transit conversion
- Corrected transit = committed transit time / achievement rate
2. Baseline transit
- Baseline transit: the minimum corrected transit among all carriers in the same route group
3. Timeliness score conversion
- Timeliness score = Max(0, (2 - corrected transit / baseline transit) × 100)
Note: when corrected transit is twice the baseline or more, the score is 0.`,
        comprehensive: 'Total bid score = cost score × 80% + timeliness score × 20%'
      }
    },
    messages: {
      loadFailed: 'Failed to load bid opening details. Please try again later.',
      exportFailed: 'Failed to export bid information. Please try again later.'
    }
  },
  award: {
    title: 'Assign Winners',
    allocationModalTitle: 'Cross-bid Evaluation — {code}',
    notificationModalTitle: 'Confirm Award and Send Notifications — {code}',
    status: { draft: 'Award Draft', committed: 'Awarded' },
    steps: { allocation: 'Allocate Award Results', notification: 'Confirm / Notify' },
    actions: {
      back: 'Back', refresh: 'Refresh Status', retry: 'Retry', remove: 'Remove', delete: 'Delete', addWinner: 'Add Winner',
      cancel: 'Cancel', previous: 'Back to Edit', saveDraft: 'Save Draft', confirmAllocation: 'Confirm',
      saveAward: 'Save Award', saveAndSend: 'Save Award and Send Notification Email', commit: 'Confirm Award'
    },
    result: {
      title: 'Award Submitted',
      subtitle: 'Award version {version}, submitted at {time}'
    },
    allocation: {
      title: 'Allocate Award Results',
      instruction: 'Select a winning supplier and allocation first, then add line codes one by one. Each line shows its total fee and overall score. Set FCL awards by container type, with up to {count} non-duplicate winning suppliers per container type; LCL/AIR allows up to {count} per tender scheme. Each container type or route must total no more than 100%.',
      winnerLimit: 'Up to {count} winning suppliers per award dimension',
      dimensionCount: '{count} award dimension(s)',
      noCandidate: 'No qualified quote is available for this dimension.',
      importAllSupplierPrices: 'Import all submitted supplier quotes into the rate library',
      importAllSupplierPricesHint: 'By default, only confirmed winning quotes are imported. When enabled, all valid quotes from winning suppliers remain active, while all valid quotes from non-winning suppliers are imported as disabled drafts.',
      scheme: 'Tender Scheme',
      benchmark: 'Benchmark',
      container: 'Container Type',
      supplier: 'Winning Supplier',
      supplierPlaceholder: 'Select a supplier',
      quote: 'Winning Quote',
      quotePlaceholder: 'Select a candidate quote',
      percentage: 'Allocation',
      percentageWithUnit: 'Allocation (%)',
      percentagePlaceholder: '1 - 100',
      routeDetails: 'Line Details',
      lineCodes: 'Line Codes',
      lineCodesPlaceholder: 'Select line codes',
      totalPrice: 'Total Fee',
      containsReference: 'Includes Reference Price',
      comprehensiveScore: 'Overall Score',
      operation: 'Action',
      total: 'Total Allocation',
      fullAward: '✓ Fully Awarded',
      partialAward: 'Partially Awarded',
      overAward: 'Cannot exceed 100%',
      winnerCount: '{current}/{limit} winning suppliers',
      noWinner: 'No winner yet. Use the button below to add one.',
      addLineCode: '+ Add Line Code',
      allLinesAdded: 'All lines added',
      selectSupplierFirst: 'Select a supplier first',
      selectAtLeastOneLine: 'Add at least one line code',
      containerLinesAdded: 'All lines for this supplier and container type have been added',
      routeLinesAdded: 'All lines for this supplier have been added',
      completeCurrentWinner: 'Complete the current winner first',
      containerWinnerLimit: 'Up to {count} winning suppliers for this container type',
      routeWinnerLimit: 'Up to {count} winning suppliers',
      noMoreSupplier: 'No more suppliers available',
      candidateMeta: 'Validity {validity} · {count} line code(s)'
    },
    notification: {
      title: 'Confirm Award Results and Notifications',
      mailOptional: 'Email notifications are optional and disabled by default.'
    },
    review: {
      title: 'Award Results',
      count: '{count} winning quote(s)',
      transportMode: 'Transport Mode',
      route: 'Route',
      container: 'Container Type',
      supplier: 'Winning Supplier',
      price: 'Winning Price',
      percentage: 'Allocation',
      lineCodes: 'Line Codes',
      empty: 'No award allocation.'
    },
    mail: {
      recipientCount: '{count} sendable',
      template: 'Email Template',
      templatePlaceholder: 'Select an email template',
      subject: 'Subject',
      subjectPlaceholder: 'Enter the email subject',
      content: 'Email Content',
      contentPlaceholder: 'Enter the email content',
      companies: 'Recipient Companies',
      companiesPlaceholder: 'Select recipient companies',
      noEmail: 'Email not provided',
      awardCount: '· {count} awarded line(s)',
      disabled: 'This email will not be sent for this award.',
      preview: 'Email Preview',
      previewRecipient: 'Preview recipient: {supplier}',
      previewSubject: 'Subject:',
      previewEmpty: 'Select a recipient company to generate a personalized preview.',
      winner: { title: 'Send award notices (separate email per supplier with lines and prices)' },
      thankYou: { title: 'Send thank-you emails (non-winning suppliers only; no winner details)' }
    },
    confirm: {
      title: 'Confirm Award Submission',
      content: 'Submitting locks the award results and writes winning rates directly to the rate warehouse. Continue?'
    },
    tasks: {
      emailTitle: 'Email Delivery',
      count: '{count} task(s)',
      status: 'Status',
      retryCount: 'Retries',
      lastError: 'Latest Error',
      operation: 'Action',
      emailType: 'Email Type',
      supplier: 'Recipient Company',
      emailTypes: { WINNER: 'Award Notice', THANK_YOU: 'Non-award Thank-you' },
      emailStatuses: {
        PENDING: 'Pending', SENDING: 'Sending', RETRY: 'Retry Pending', SENT: 'Sent', FAILED: 'Failed', CANCELLED: 'Cancelled'
      }
    },
    messages: {
      loadFailed: 'Failed to load award data. Refresh and try again.',
      templateLoadFailed: 'Failed to load email templates. Please try again later.',
      dimensionRequired: 'Set at least one winning quote for "{dimension}".',
      winnerLimit: '"{dimension}" can have at most {count} winning suppliers.',
      supplierRequired: 'Select a winning supplier for "{dimension}".',
      quoteRequired: '"{dimension}" contains an allocation without a candidate quote.',
      percentageInvalid: 'The allocation for "{dimension}" must be an integer from 1 to 100.',
      lineCodeRequired: 'Select at least one line code for "{dimension}".',
      lineCodeInvalid: '"{dimension}" contains a line code outside the selected quote.',
      duplicateSupplier: 'The same supplier cannot be selected twice for "{dimension}".',
      supplierPercentageMismatch: 'All winning quotes from supplier "{supplier}" in "{dimension}" must use the same allocation.',
      duplicateQuote: 'The same quote row cannot be allocated twice.',
      percentageExceeded: 'The allocation total for "{dimension}" is {total}% and cannot exceed 100%.',
      allocationRequired: 'Set at least one winning quote.',
      mailContentRequired: 'Complete the template, subject, and content for "{type}".',
      mailSupplierRequired: 'Select at least one valid recipient company for "{type}".',
      mailSupplierInvalid: '"{type}" contains an out-of-scope recipient or a company without an email address.',
      saveSuccess: 'Award draft saved.',
      saveFailed: 'Failed to save the award draft. Refresh and try again.',
      commitSuccess: 'Award submitted successfully.',
      commitFailed: 'Failed to submit the award. Check the data or refresh and try again.',
      retrySubmitted: 'Retry submitted.',
      retryFailed: 'Failed to submit the retry. Please try again later.'
    }
  },
  supplierBid: {
    languageSwitch: '中文',
    title: 'Bid Quote: {title} ({code})',
    detailTitle: 'Bid Details: {title} (Bid No.: {code})',
    detailDefaultTitle: 'Bid Details',
    defaultTitle: 'Bid Quote',
    status: { draft: 'Draft', submitted: 'Submitted' },
    actions: {
      saving: 'Saving...', saveDraft: 'Save Draft', submitting: 'Submitting...', submit: 'Submit Bid',
      download: 'Download', delete: 'Delete', close: 'Close', cancel: 'Cancel', confirm: 'Confirm',
      history: 'Quote History', batchImport: 'Import Quotes', addQuote: 'Add Quote Row', removeQuote: 'Delete Quote Rows',
      exportCurrent: 'Export Current Tab', exportTemplate: 'Export Quote Template', exportCsv: 'Export to CSV',
      confirmSubmit: 'Submit', checkAgain: 'Review Again'
    },
    loading: 'Loading bid information...',
    invalidLinkHelp: 'Contact the tendering company for a new invitation link.',
    submittedHint: 'This bid was submitted at {time} and can no longer be edited under the tender rules.',
    readonlyHint: 'Bidding is currently closed. This page is read-only. Bidding period: {start} to {end}.',
    sections: {
      basic: 'Basic Information', tenderRemark: 'Tender Remarks', tenderAttachments: 'Tender Attachments',
      supplier: 'Bidder Information', bidRemark: 'Bid Remarks', upload: 'File Upload', routes: 'Routes and Quotes'
    },
    fields: {
      tenderCode: 'Tender No.', tenderCompany: 'Tendering Company', tenderType: 'Tender Type', cargoType: 'Cargo Type', tenderRound: 'Tender Round',
      biddingMethod: 'Bidding Method', bidNumber: 'Bid No.', tenderNumber: 'Tender Reference', bidStatus: 'Bid Status',
      roundValue: 'Round {current} / {total}', startTime: 'Start Time', endTime: 'End Time',
      requireDeposit: 'Deposit Required', depositAmount: 'Deposit Amount', depositDeadline: 'Deposit Deadline',
      supplierName: 'Bidder Company', contact: 'Contact', email: 'Email', none: 'None'
    },
    placeholders: { contact: 'Enter contact name', email: 'Enter email address', remark: 'Optional bid remarks', input: 'Enter a value', select: 'Select', scheme: 'Select a tender scheme', container: 'Select a container type', carrier: 'Select', warehouse: 'Select a warehouse', searchPort: 'Search by code or name', searchKeyword: 'Search by keyword', noCarrier: 'No carriers available', noPort: 'No ports available', noTransitLocation: 'No matching ports or airports', noSearchResult: 'No matching options', noWarehouse: 'No warehouses available', weekday: 'Select' },
    common: { yes: 'Yes', no: 'No' },
    tenderTypes: { year: 'Annual Tender', quarter: 'Quarterly Tender', month: 'Monthly Tender' },
    serviceTypes: { economy: 'Economy', express: 'Express' },
    routingTypes: { direct: 'Direct', transit: 'Transit' },
    attachments: {
      bid: 'Bid Attachments', uploaded: 'Uploaded Files ({count})', fileName: 'File Name', uploadTime: 'Uploaded At', operation: 'Actions',
      emptyTender: 'No tender attachments', emptyBid: 'No files', drop: 'Click or drag files here to upload',
      formats: 'PDF, Word, Excel, and image files are supported', size: 'Maximum size per file: 10 MB',
      depositHint: 'If a deposit has been paid, upload the payment certificate.'
    },
    route: {
      helpTitle: 'Instructions', helpLocked: 'Tender-provided fields are locked. The supplier fills in validity, transit information, and fees.',
      helpOptional: 'Optional fees default to 0. Enter all fees actually incurred.',
      helpRows: 'Each tender container type has one row by default. Only selected rows are saved and submitted.',
      exportHintPrefix: 'To export a quote template, right-click', exportHintCell: 'any data cell', exportHintMiddle: 'and choose Export →',
      exportHintExcel: 'Export to Excel / CSV', exportHintSuffix: '. Complete the file and upload it through Import Quotes.',
      selectedAll: '{count} quote row(s) selected. These selections will be included when saving or submitting.',
      requiredFee: '* Required fee', footer: '{total} quote row(s), {selected} selected',
      schemeTooltip: 'Tender scheme: origin country-origin port/airport-origin city-origin warehouse-destination country-destination port/airport-destination city-destination warehouse; only tender-provided fields are shown',
      transitPortTooltip: 'Multiple transit ports or airports can be selected.',
      weekdayTooltip: 'Multiple selections allowed. D1 is Monday and D7 is Sunday; saved as D1/D3/D5.'
    },
    weekdays: { d1: 'D1 Monday', d2: 'D2 Tuesday', d3: 'D3 Wednesday', d4: 'D4 Thursday', d5: 'D5 Friday', d6: 'D6 Saturday', d7: 'D7 Sunday' },
    modes: { fcl: 'FCL', lcl: 'LCL', air: 'AIR' },
    feeGroups: { validity: 'Rate Validity', transit: 'Transit Information', origin: 'Pre-carriage', basic: 'Mainline', destination: 'On-carriage' },
    feeLimits: { min: 'Min', max: 'Max', minHeader: '{fee} MIN', maxHeader: '{fee} MAX', minTooltip: '{fee} · Minimum', maxTooltip: '{fee} · Maximum' },
    columns: {
      index: 'No.', scheme: 'Tender Scheme', originCountry: 'Origin Country', originPort: 'Origin Port', originAirport: 'Origin Airport',
      originCity: 'Origin City', originWarehouse: 'Origin Warehouse', destinationCountry: 'Destination Country', destinationPort: 'Destination Port',
      destinationAirport: 'Destination Airport', destinationCity: 'Destination City', destinationWarehouse: 'Destination Warehouse',
      serviceType: 'Service Type', transportClause: 'Transport Terms', tradeClause: 'Trade Terms', tenderRemark: 'Tender Remarks',
      routingType: 'Routing Type*', transitPort: 'Transit Port', transitAirport: 'Transit Airport',
      weight: 'Weight (kg)', cbm: 'Volume (CBM)', containerType: 'Container Type', minPrice: 'Minimum Price', maxPrice: 'Maximum Price', quantity: 'Quantity',
      effectiveDate: 'Effective Date*', expiryDate: 'Expiry Date*', airline: 'Airline*', carrier: 'Carrier*',
      flightSchedule: 'Flight Schedule*\nWeekday', sailingSchedule: 'Sailing Schedule*\nWeekday', transitDays: 'Transit Time*\nDays',
      airFreeStorage: 'Airport Free Storage*\nHrs', cfsFreeStorage: 'CFS Free Storage*\nHrs', achievement: 'On-time Rate*\n%',
      portFreeDetention: 'Destination Free Detention*\nDays', portFreeStorage: 'Destination Free Storage*\nDays', clearanceDays: 'Destination Clearance*\nDays',
      overallAchievement: 'Overall On-time Rate*\n%', bidRemark: 'Bid Remarks'
    },
    history: { time: 'Time', operator: 'Operator', type: 'Action', remark: 'Remarks', empty: 'No quote history' },
    import: {
      exportTitle: 'Export Quote Template', exportTip: 'Right-click any quote-grid data cell and export Excel or CSV, then complete and upload the file here. The template contains only existing quote rows in the current tab. To add more quotes, first add rows on the page and select a tender scheme. Read-only tender cells are locked in Excel, and imports cannot change the original tender values.',
      uploadTitle: 'Upload File', dropPrefix: 'Drag a file here or ', click: 'click to upload',
      format: '.xls, .xlsx, and .csv files are supported', recognized: '{count} quote row(s) recognized',
      scanSummary: '{total} data row(s) scanned',
      importableSummary: '{count} row(s) ready to import',
      issueSummary: '{count} row(s) have issues. View details',
      validating: 'Validating...'
    },
    importErrors: {
      title: 'Import Validation Failed',
      summary: '{count} issue(s) were found. No quotes were applied. Correct the file and import it again.',
      summaryPartial: '{count} issue(s) were found. {valid} quote row(s) can still be imported now.',
      sheet: 'Sheet',
      row: 'Row',
      column: 'Field',
      value: 'Original Value',
      reason: 'Issue',
      currentDuplicate: 'The entered information in this quote row, excluding bid remarks, matches another row on the page. Remove the duplicate.',
      originalRowMissing: 'The original quote row no longer exists. Export a new template and try again.'
    },
    messages: {
      invalidLink: 'The tender ID or company-specific token is missing. This bid page cannot be opened.', contactRequired: 'Enter a contact name.',
      emailInvalid: 'Enter a valid contact email.', quoteRequired: 'Select at least one route or container type to quote.',
      validityRequired: 'Enter the rate validity for route {route}.', dateOrderInvalid: 'The expiry date for route {route} cannot be earlier than the effective date.',
      feeBoundsInvalid: 'Min/Max for {fee} must be non-negative, and Min must not exceed Max.',
      feeRequired: 'Enter the required fee for route {route}: {fee}', draftSaved: 'Draft saved.', submitTitle: 'Confirm Bid Submission',
      submitContent: 'This bid cannot be edited after submission. Confirm that all quote information is correct.', submitted: 'Bid submitted successfully.',
      noScheme: 'No {mode} tender scheme is available.', schemeRequired: 'Select a tender scheme for each new quote row.',
      containerRequired: 'Select a container type under tender scheme {route}.',
      portsRequired: 'Select the origin and destination ports for tender scheme {route}.',
      duplicateQuote: 'Tender scheme {route} has quote rows with identical entered information excluding bid remarks. Remove duplicates before submitting.',
      duplicateQuoteRows: 'Rows {rows} have identical entered information excluding bid remarks. Remove duplicates before submitting. You can save a draft first.',
      selectDelete: 'Select quote rows to delete.',
      transitRequired: 'Complete the transit information for route {route}.', ddRequired: 'Complete the POD D&D information for route {route}.',
      achievementRateRangeInvalid: 'The overall achievement rate for route {route} must be between 0 and 100.',
      fileTooLarge: '{name} exceeds 10 MB and was skipped.', uploadSuccess: 'Files uploaded. Save the draft or submit the bid.',
      xlsxRequired: 'Upload an .xls, .xlsx, or .csv file.', sheetMissing: 'The file does not contain a worksheet.', parsed: '{count} quote row(s) recognized.',
      parsedNone: 'No importable quotes were recognized. Review the issue details and fix the file.',
      parsedPartial: '{valid} quote row(s) can be imported; {invalid} row(s) have issues.',
      imported: '{count} quote row(s) imported. Save the draft or submit the bid.',
      importedPartial: '{applied} quote row(s) imported; {skipped} row(s) were skipped because they duplicate quotes already on this page.',
      carrierImportUnmatched: '{count} quote row(s) contain carrier names that do not match this tenant\'s master data. Select them again in the grid.',
      scheduleImportInvalid: '{count} quote row(s) contain invalid vessel or flight weekdays. Select D1 through D7 again in the grid.', requestFailed: 'Request failed. Please try again later.'
    },
    excel: {
      quoteId: 'Quote Row ID', participating: 'Participating', routeCode: 'Route Code', containerType: 'Container Type', originPort: 'Origin Port/Airport', originPortFcl: 'Origin Port', originAirport: 'Origin Airport', destinationPort: 'Destination Port/Airport', destinationPortFcl: 'Destination Port', destinationAirport: 'Destination Airport', routingType: 'Routing Type', transitPort: 'Transit Port/Airport', transitPortFcl: 'Transit Port', transitAirport: 'Transit Airport', effectiveDate: 'Effective Date',
      expiryDate: 'Expiry Date', carrier: 'Carrier', shipper: 'Shipper', transitCarrier: 'Transit Carrier', schedule: 'Schedule', vesselSchedule: 'Vessel Schedule', flightSchedule: 'Flight Schedule', bidRemark: 'Bid Remarks', fileSuffix: 'Quote Template', instructionMarker: 'Instructions: Fields marked with * are required.', readOnly: 'Read-only',
      instructions: {
        singleSelect: 'Required; select one',
        seaport: 'Read-only if provided; otherwise enter a 5-character port code',
        airport: 'Read-only if provided; otherwise enter a 3-letter airport code',
        routingType: 'Required; select Transit or Direct',
        transitSeaport: 'Required for transit; select one 5-character port code',
        transitAirport: 'Required for transit; select one 3-letter airport code',
        date: 'yyyy-mm-dd', carrier: 'Carrier code', airline: '2-letter airline code',
        schedule: 'Select D1 to D7;\ne.g. D1/D7', number: 'Number', amount: 'Number (use 2 decimal places)'
      },
      transitDays: 'Transit Time (Days)',
      airFreeStorage: 'Airport Free Storage (Hrs)', cfsFreeStorage: 'CFS Free Storage (Hrs)', achievement: 'On-time Rate (%)',
      portFreeDetention: 'Destination Free Detention (Days)', portFreeStorage: 'Destination Free Storage (Days)', clearanceDays: 'Destination Clearance (Days)',
      overallAchievement: 'Overall On-time Rate (%)'
    }
  }
}
